import {useMobileOrTablet} from '@helpers/hooks/useWindow';

export const LinearGradientLine = ({style}) => {
  const defaultLinearGradientStyle = {
    background: 'linear-gradient(90deg, #26292B 52.96%, rgba(50, 54, 58, 0) 90.63%)',
    height: 3,
    width: '100%',
  };
  const mergedStyle = {...defaultLinearGradientStyle, ...style};
  return <div style={mergedStyle}/>;
};


export const SitePageHeaderFontStyling = ({title, children, ...props}) => {
  const style = props?.style;
  const isMobile = useMobileOrTablet();
  const headerFontSize = isMobile ? '24px' : '36px';

  return (
    <>
      <div style={{paddingTop: '10px', marginBottom: '8px', ...style}}>
        <h1 className="font-oswald uppercase my-2 w-full" style={{fontSize: headerFontSize}}>
          {title}
        </h1>
      </div>
      <LinearGradientLine/>
    </>
  );
};

export const CustomerLoginPageHeader = ({isMobile, title}) => {
  const headerStyle = {
    fontSize: isMobile ? '24px' : '32px',
  };

  const marginBottomStyle = {
    marginBottom: 8,
  };

  return (
    <>
      <div style={marginBottomStyle}>
        <h1 className="font-oswald uppercase my-2 dark:bg-white" style={headerStyle}>
          {title}
        </h1>
      </div>
      <LinearGradientLine/>
    </>
  );
};


export function AccountRegistrationFormHeader({title, children}) {
  const isMobile = useMobileOrTablet()

  return <>
    <h1
      className="font-oswald uppercase my-2 w-full"
      style={{
        fontSize: isMobile ? '24px' : '32px',
        marginLeft: isMobile ? '' : null,
      }}
    >
      <div
        style={{
          marginBottom: 8,
        }}
      >
        {title} {children}
      </div>
      <LinearGradientLine/>
    </h1>
  </>
}

export function ForgotPasswordPageHeader({title, children}) {
  const isMobile = useMobileOrTablet()

  return <>
    <h1
      className="font-oswald uppercase my-2 w-full"
      style={{
        fontSize: isMobile ? '24px' : '32px',
        marginLeft: !isMobile ? '' : null,
      }}
    >
      <div
        style={{
          marginBottom: 8,
        }}
      >
        {title} {children}
      </div>
      <LinearGradientLine/>
    </h1>
  </>
}

export function UpdateForgottenPasswordPageHeader({title, children}) {
  const isMobile = useMobileOrTablet()

  return <>
    <h1
      className="font-oswald uppercase my-2 w-full"
      style={{
        fontSize: isMobile ? '24px' : '32px',
        marginLeft: !isMobile ? '' : null,
      }}
    >
      <div
        style={{
          marginBottom: 8,
        }}
      >
        {title} {children}
      </div>
      <div
        style={{
          background: 'linear-gradient(90deg, #26292B 52.96%, rgba(50, 54, 58, 0) 90.63%)',
          height: 3,
          width: '100%',
        }}
      />
    </h1>
  </>
}
